import { render, staticRenderFns } from "./AccettazioneSsnRicettaPrestazioniComponent.vue?vue&type=template&id=49cbe71c"
import script from "./AccettazioneSsnRicettaPrestazioniComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnRicettaPrestazioniComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports